import * as React from 'react';

function ReferralImage() {
	return (
		<div className='referral-image'>
			<svg viewBox='0 0 200 155' xmlns='http://www.w3.org/2000/svg'>
				<path
					className='cls-12'
					d='M 198.63,144.87 H 1.37 a 0.37,0.37 0 1 1 0,-0.74 h 197.26 a 0.37,0.37 0 0 1 0,0.74 z'
					id='path172'
				/>
				<g id='Layer_2' data-name='Layer 2' transform='matrix(0.40487763,0,0,0.40487763,6.182155,8.004851)'>
					<path
						className='cls-3'
						d='m 41.65,81.11 a 27.7,27.7 0 1 1 21,33.24 l 3.07,6.41 -9.46,-2.26 5.64,-4.33 A 27.58,27.58 0 0 1 41.65,81.11 Z'
						id='path1'
					/>
					<path className='cls-3' d='M 73.48,66.88 A 21.18,21.18 0 0 0 50,77.33' id='path2' />
					<path
						className='cls-3'
						d='m 61.31,121.54 c 0,0 1.89,16.87 -13.18,23.68 -15.07,6.81 -16,17 -16,17 0,0 -0.24,13.37 -10.41,18.38'
						id='path3'
					/>
					<g id='g59' transform='translate(-32.240979)'>
						<path
							className='cls-4'
							d='M 328.81,177.8 H 200.56 a 1.93,1.93 0 0 0 -1.65,0.94 l -17.51,29.18 a 7.07,7.07 0 0 0 -1,3.64 v 123.27 a 1.93,1.93 0 0 0 1.93,1.93 h 169.46 a 0.28,0.28 0 0 0 0.28,-0.28 V 211.82 a 7.07,7.07 0 0 0 -1.28,-4.05 l -20.4,-29.14 a 1.93,1.93 0 0 0 -1.58,-0.83 z'
							id='path4'
						/>
						<g className='cls-5' id='g5'>
							<line className='cls-6' x1='187.82001' y1='217.91' x2='246.77' y2='217.98' id='line4' />
							<path
								className='cls-6'
								d='m 246.77,218.73 v 0 l -58.94,-0.07 a 0.76,0.76 0 0 1 0,-1.51 v 0 l 58.94,0.07 a 0.76,0.76 0 0 1 0,1.51 z'
								id='path5'
							/>
						</g>
						<g className='cls-5' id='g6'>
							<path
								className='cls-6'
								d='m 327.68,218.73 h -48.27 a 0.76,0.76 0 0 1 0,-1.51 h 48.26 a 0.76,0.76 0 0 1 0,1.51 z'
								id='path6'
							/>
						</g>
						<g className='cls-5' id='g7'>
							<path
								className='cls-6'
								d='m 341.57,218.73 h -8 a 0.76,0.76 0 1 1 0,-1.51 h 8 a 0.76,0.76 0 0 1 0,1.51 z'
								id='path7'
							/>
						</g>
						<path
							className='cls-7'
							d='m 343.35,328 a 1.93,1.93 0 0 1 -1.93,1.93 h -25.85 a 0.76,0.76 0 1 1 0,-1.51 h 24.34 a 1.93,1.93 0 0 0 1.93,-1.93 v -16.6 a 0.76,0.76 0 1 1 1.51,0 z'
							id='path8'
						/>
						<path className='cls-8' d='m 342.59,305.53 v -3.36' id='path9' />
						<path
							className='cls-9'
							d='m 325.15,338.27 h 21.69 a 1.93,1.93 0 0 0 1.93,-1.93 v -123 a 7.07,7.07 0 0 0 -1.28,-4.05 l -20.4,-29.14 a 1.93,1.93 0 0 0 -1.58,-0.82 H 197.26 a 1.93,1.93 0 0 0 -1.65,0.94 l -17.51,29.15 a 7.07,7.07 0 0 0 -1,3.64 v 123.28 a 1.93,1.93 0 0 0 1.93,1.93 h 97.24'
							id='path10'
						/>
						<path className='cls-10' d='m 281.35,338.27 h 25.1' id='path11' />
						<path className='cls-10' d='M 310.8,338.27 H 319' id='path12' />
						<path
							className='cls-11'
							d='m 274.5,339.07 h -17.15 a 2.55,2.55 0 0 1 -2.55,-2.55 V 213.64 h 22.25 v 122.88 a 2.55,2.55 0 0 1 -2.55,2.55 z'
							id='path13'
						/>
						<polygon
							className='cls-11'
							points='193.38,188.7 336.89,188.7 344.44,199.28 187.34,199.28 '
							id='polygon13'
						/>
						<rect className='cls-9' x='252.56' y='212.88' width='22.25' height='124.68' id='rect13' />
						<path
							className='cls-12'
							d='M 348,213.56 H 179 a 0.76,0.76 0 0 1 0,-1.51 h 169 a 0.76,0.76 0 1 1 0,1.51 z'
							id='path14'
						/>
						<polygon
							className='cls-9'
							points='190.36,188.7 333.17,188.7 340.69,199.28 184.34,199.28 '
							id='polygon14'
						/>
						<polygon
							className='cls-11'
							points='254.56,212.88 256.54,179.63 274.83,179.63 276.81,212.88 '
							id='polygon15'
						/>
						<polygon
							className='cls-9'
							points='252.56,212.88 254.54,179.63 272.83,179.63 274.81,212.88 '
							id='polygon16'
						/>
						<path
							className='cls-13'
							d='m 318,164.85 -18.58,-11.47 c 0,0 9.55,30.21 -32.17,39.5 -0.03,0.01 42.75,0.52 50.75,-28.03 z'
							id='path16'
						/>
						<path
							className='cls-11'
							d='m 264.53,193.35 c 0,0 4.91,-43 43.06,-40.61 L 318,164.85 c 0,0 -14.62,-7.51 -53.47,28.5 z'
							id='path17'
						/>
						<path
							className='cls-13'
							d='m 211.76,166.75 18.21,-12 c 0,0 -8.6,30.49 33.38,38.48 0,-0.04 -42.78,1.77 -51.59,-26.48 z'
							id='path18'
						/>
						<path
							className='cls-11'
							d='m 266.06,193.56 c 0,0 -6.25,-42.84 -44.31,-39.25 l -10,12.43 c 0,0 14.36,-7.96 54.31,26.82 z'
							id='path19'
						/>
						<path
							className='cls-11'
							d='m 266.41,193.06 c 0,0 35.69,6.49 47.59,26 l -13,1.08 c 0,0 3.24,6.49 3.24,8.65 0,2.16 -22.69,-34.65 -37.83,-35.73 z'
							id='path20'
						/>
						<path
							className='cls-11'
							d='m 266.41,193.06 c 0,0 -40,17.3 -51.91,36.77 l 13,1.08 c 0,0 -3.24,6.49 -3.24,8.65 0,2.16 27.01,-45.42 42.15,-46.5 z'
							id='path21'
						/>
						<path
							className='cls-14'
							d='m 297.27,168.61 c -2.52,9 -10.35,19.44 -32,24.28 0,0 42.5,0.5 50.66,-27.71'
							id='path22'
						/>
						<path
							className='cls-14'
							d='m 262.53,193.35 c 0,0 4.91,-43 43.06,-40.61 L 316,164.85 c 0,0 -14.62,-7.51 -53.47,28.5 z'
							id='path23'
						/>
						<path
							className='cls-14'
							d='m 228.41,169.39 c 2.64,9 10.67,19.56 32.94,23.8 0,0 -42.79,1.84 -51.59,-26.44 l 0.34,-0.23'
							id='path24'
						/>
						<path
							className='cls-14'
							d='m 264.06,193.56 c 0,0 -6.25,-42.84 -44.31,-39.25 l -10,12.43 c 0,0 14.36,-7.96 54.31,26.82 z'
							id='path25'
						/>
						<path
							className='cls-14'
							d='m 264.41,193.06 c 0,0 35.69,6.49 47.59,26 l -13,1.08 c 0,0 3.24,6.49 3.24,8.65 0,2.16 -22.69,-34.65 -37.83,-35.73 z'
							id='path26'
						/>
						<path
							className='cls-14'
							d='m 264.41,193.06 c 0,0 -40,17.3 -51.91,36.77 l 13,1.08 c 0,0 -3.24,6.49 -3.24,8.65 0,2.16 27.01,-45.42 42.15,-46.5 z'
							id='path27'
						/>
					</g>
					<path className='cls-20' d='m 296.91,57.21 h 3.92' id='path50' />
					<path className='cls-20' d='M 303.87,57.22 448.32,57.3' id='path51' />
					<path
						className='cls-20'
						d='m 310,56.78 a 17.22,17.22 0 0 1 25,-15.38 19.34,19.34 0 0 1 29,-8.4 29,29 0 0 1 55.26,3.21 h 0.88 a 21,21 0 0 1 21,21 H 310 c 0,-0.15 0,-0.29 0,-0.43 z'
						id='path52'
					/>
					<path
						className='cls-20'
						d='m 420,47.52 a 30.18,30.18 0 0 0 0.19,-3.33 q 0,-0.75 0,-1.49'
						id='path53'
					/>
					<path className='cls-20' d='M 420.19,40.92 A 29.7,29.7 0 0 0 419,35.37' id='path54' />
					<path className='cls-20' d='m 344.07,33.8 a 14.53,14.53 0 0 1 5.78,-2' id='path55' />
					<path className='cls-20' d='m 338.13,40.36 a 11.76,11.76 0 0 1 5.05,-5.89' id='path56' />
					<path
						className='cls-20'
						d='m 368.15,38.58 a 16.67,16.67 0 0 0 -2,-3.29 17.2,17.2 0 0 0 -2.71,-2.72'
						id='path57'
					/>
					<path className='cls-20' d='m 335.11,41 a 16.12,16.12 0 0 0 -0.83,3.94' id='path58' />
				</g>
			</svg>
		</div>
	);
}

export { ReferralImage };
